var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagePhotoPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13.8284 7 14.5 6.32843 14.5 5.5C14.5 4.67157 13.8284 4 13 4C12.1716 4 11.5 4.67157 11.5 5.5C11.5 6.32843 12.1716 7 13 7Z",
    fill: "#C1CFDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5V17.5C0.5 17.78 0.72 18 1 18H20C20.28 18 20.5 17.78 20.5 17.5V0.5C20.5 0.22 20.28 0 20 0H1C0.72 0 0.5 0.22 0.5 0.5ZM2.5 2H18.5V8.58L16.85 6.94C16.65 6.75 16.34 6.75 16.14 6.94L12.49 10.59L6.84 4.94C6.64 4.74 6.33 4.74 6.13 4.94L2.48 8.58V2H2.5ZM18.5 16H2.5V11.42L6.5 7.41L12.15 13.06C12.35 13.26 12.66 13.26 12.86 13.06L16.51 9.41L18.51 11.42V16H18.5Z",
    fill: "#C1CFDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePhotoPicture);
export default __webpack_public_path__ + "static/media/ImagePhotoPicture.aa9cc9b56b06655f5fe9da57a5231891.svg";
export { ForwardRef as ReactComponent };